(() => {
  if (customElements.get('aw-stock-indicator')) return;
  customElements.define('aw-stock-indicator', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.productRoot = this.closest('[data-section-type="product"]');
      this.label = this.querySelector('.aw-stock-indicator__text');
      try {
        this.variants = JSON.parse(this.querySelector('[data-aw-indicator-variants]')?.textContent || '[]');
      } catch {
        this.variants = [];
      }
      if (!this.productRoot || !this.label) return;
      const signal = this.abortController.signal;
      this.productRoot.addEventListener('variant:change', () => this.scheduleSync(), {signal});
      this.productRoot.addEventListener('change', event => {
        if (!(event.target instanceof Element)) return;
        if (event.target.matches('form[action*="/cart/add"] [name="id"]') || event.target.closest('.variant-wrapper, .variant-picker, variant-swatch-king')) this.scheduleSync();
      }, {signal});
      this.scheduleSync();
    }
    scheduleSync() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.frame = requestAnimationFrame(() => this.sync());
      });
    }
    sync() {
      if (!this.isConnected) return;
      const id = this.productRoot.querySelector('form[action*="/cart/add"] [name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      this.label.textContent = variant.available ? this.label.dataset.available : this.label.dataset.unavailable;
    }
    disconnectedCallback() {
      this.abortController?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
})();
